import React, { useEffect } from "react";
import Otp from "./otpRegister";
import Fixedbg from "../FixedBaground/Fixedbg";
import Header from "../Header/header";
import TermModal from "../pages/temsmodal";
import Button from 'react-bootstrap/Button';

import { useState } from "react";
import { useHistory } from "react-router-dom";
import env from "react-dotenv";
import countries from "./Data/countries.json";
import cities from "./Data/cities.json";
import { API_BASE_URL } from "@/config/serverApiConfig";
import axios from "axios";
import { Modal, Spinner } from "react-bootstrap";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Footer from "../Footer/footer";
import country_list from '../all-countries-and-cities-json'
import SubmitPopup from "../Submitpopup/Submitpopup";
import ReCAPTCHA from "react-google-recaptcha";


const Signup = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  
  const history = useHistory();

  if (
    localStorage.getItem("token") === null ||
    localStorage.getItem("token") === undefined
  ) {

  } else if (
    localStorage.getItem("token") !== null ||
    localStorage.getItem("user_id") !== undefined
  ) {
    history.push("/dashboard");
  }

  const [resLogin, setresLogin] = useState(
    {
      message: "",
      success: "",
      data: {
        user_id: "",
        email: ""
      }
    }
  );
  const [fname, setFName] = useState("");
  const [lname, setLName] = useState("");
  const [email, setEmail] = useState("");
  let [phone, setPhone] = useState("");
  const [user_id, setUserID] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [cityList, setCityList] = useState({});
  const [smShow, setSmShow] = useState(false);
  const [cnicImage, setCnicImage] = useState("");
  const [cnicImageErr, setCnicImageErr] = useState(false);
  const [cnicImageIsEmptyErr, setCnicImageIsEmptyErr] = useState(false);
  const [certificate, setCertificate] = useState("");
  const [certificateName, setCertificateName] = useState("");
  const [certificateErr, setCertificateErr] = useState(false);
  const [certificateIsEmptyErr, setCertificateIsEmptyErr] = useState(false);
  const placeholder = "anything";

  //reffrence for the form

  const [reference_one_name, setReferenceOneName] = useState("");
  let [reference_one_number, setReferenceOneNumber] = useState("");
  const [reference_one_email, setReferenceOneEmail] = useState("");
  const [reference_two_name, setReferenceTwoName] = useState("");
  const [reference_two_number, setReferenceTwoNumber] = useState("");
  const [reference_two_email, setReferenceTwoEmail] = useState("");
  let [mobileNoLength, setMobileNoLength] = useState(false);
  let [mobileNoLengthOne, setMobileNoLengthOne] = useState(false);
  let [mobileNoLengthTwo, setMobileNoLengthTwo] = useState(false);
  let [terms, setTerms] = useState(false);
  // error handling for reference one and two

  const [refOneFrirstNameErr, setRefOneFrirstNameErr] = useState(false);
  const [refOneFrirstNameIsEmptyErr, setRefOneFrirstNameIsEmptyErr] =
    useState(false);
  const [refOneNumberErr, setRefOneNumberErr] = useState(false);
  const [refOneNumberIsEmptyErr, setRefOneNumberIsEmptyErr] = useState(false);

  const [refTwoNameErr, setRefTwoFrirstNameErr] = useState(false);
  const [refTwoNameIsEmptyErr, setRefTwoFrirstNameIsEmptyErr] = useState(false);
  const [refTwoNumberErr, setRefTwoNumberErr] = useState(false);
  const [refTwoNumberIsEmptyErr, setRefTwoNumberIsEmptyErr] = useState(false);

  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "",
  });

  let [recap, setRecap] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);
  function onChange(value) {
    console.log("Captcha value:", value);
    if(value){
       setRecap(true);
       setRecaptchaError(false);
    }
  }
  const handleImg = (e) => {
    setCnicImageIsEmptyErr(false);
    if (e.target.files[0]) {
      setCnicImage(e.target.files[0]);
      setImg({
        src: URL.createObjectURL(e.target.files[0]),
        alt: e.target.files[0].name,
      });
      
    }
  };

  //models

  const [submitLoader, setSubmitLoader] = useState(false);
  const loaderClose = () => setSubmitLoader(false);

  //error handling and validations for email
  const [emailErr, setEmailErr] = useState(false);
  const [emailIsEmptyErr, setemailIsEmptyErr] = useState(false);

  // handing validation for phone
  const [phoneErr, setPhoneErr] = useState(false);
  const [phoneIsEmptyErr, setPhoneIsEmptyErr] = useState(false);

  // handing validation for first name
  const [fnameTypeErr, setFnameTypeErr] = useState(false);
  const [fnameErr, setFNameErr] = useState(false);
  const [fnameIsEmptyErr, setFNameIsEmptyErr] = useState(false);

  // handing validation for last name
  const [lnameErr, setLNameErr] = useState(false);
  const [lnameIsEmptyErr, setLNameIsEmptyErr] = useState(false);

  // handing validation for country
  const [countryErr, setCountryErr] = useState(false);
  const [countryIsEmptyErr, setCountryIsEmptyErr] = useState(false);

  // handing validation for city
  const [cityErr, setCityErr] = useState(false);
  const [cityIsEmptyErr, setCityIsEmptyErr] = useState(false);

  //handling validation for ref one

  const [refOneEmailErr, setRefOneEmailErr] = useState(false);
  const [refOneEmailIsEmptyErr, setRefOneEmailIsEmptyErr] = useState(false);

  //handling validation for ref two
  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  const [refTwoEmailErr, setRefTwoEmailErr] = useState(false);
  const [refTwoEmailIsEmptyErr, setRefTwoEmailIsEmptyErr] = useState(false);
  const [termsIsEmptyErr, setTermsIsEmptyErr] = useState(false);
  const [responseLogin, setResponseLogin] = useState("");
  function emailHandler(e) {
    let item = e.target.value;

    let validEmail = validEmailRegex.test(item);
    if (item === "") {
      setemailIsEmptyErr(true);
      setEmailErr(false);
    } else if (!validEmail) {
      setEmailErr(true);
      setemailIsEmptyErr(false);
    } else {
      setEmailErr(false);
      setemailIsEmptyErr(false);
    }
    setEmail(item);

  }
  
  function termshandler(e) {
    // check element by id if it is checked then set terms to true else false
    if (e.target.checked) {
      setTerms(true);
      setTermsIsEmptyErr(false);
    } else {
      setTerms(false);
     
    }

  }

  const phoneHandler = (phone) => {


    let item = phone
    

    if (item <= 0) {
      setPhoneIsEmptyErr(true);
      setPhoneErr(false);
    } else {
      setPhoneErr(false);
      setPhoneIsEmptyErr(false);
    }
    setPhone(item);
    
    
    // formData.append("phone", phone);

  }

  const validNameRegex = RegExp("([A-Z][a-z]*)([\\s\\'-][A-Z][a-z]*)*");
  function fnameHandler(e) {
    let item = e.target.value;
    let validName = validNameRegex.test(item);
    if (item === "") {
      setFNameIsEmptyErr(true);
      setFNameErr(false);
    } else if (!validName) {
      //fnameTypeErr(true)
      setFNameErr(false);
      setFNameIsEmptyErr(false);
    } else if (item.length < 3 || item.length > 20) {
      setFNameErr(true);
      setFnameTypeErr(false);
      setFNameIsEmptyErr(false);
    } else {
      setFNameErr(false);
      setFNameIsEmptyErr(false);
      setFnameTypeErr(false);
    }
    setFName(item);

  }

  function lnameHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setLNameIsEmptyErr(true);
      setLNameErr(false);
    } else if (item.length < 3 || item.length > 20) {
      setLNameErr(true);
      setLNameIsEmptyErr(false);
    } else {
      setLNameErr(false);
      setFNameIsEmptyErr(false);
    }
    setLName(item);

  }

  function countryHandler(e) {
    let item = e.target.value;
    let country = "";
    //countries.map(countriess,(item)=>{

    if (item === "") {
      setCountryIsEmptyErr(true);
      setCountryErr(false);
    } else country = countries.find((country) => country.name === item);

    setCountry(country);

  }
  function cityHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setCityIsEmptyErr(true);
      setCityErr(false);
    } else {
      setCityErr(false);
      setCityIsEmptyErr(false);
    }
    setCity(item);
    // formData.append("city", city);
  }



  function certificateHandler(e) {
    setCertificateIsEmptyErr(false);
    let item = e.target.value;
    if (item.length < 1) {
      setCertificateIsEmptyErr(true);
      setCertificateErr(false);
    } else {
      setCertificateName(e.target.files[0].name);
      setCertificate(e.target.files[0]);

    }
  }

  function refOneFrirstNameHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setRefOneFrirstNameIsEmptyErr(true);
      setRefOneFrirstNameErr(false);
    } else if (item.length < 3 || item.length > 20) {
      setRefOneFrirstNameErr(true);
      setRefOneFrirstNameIsEmptyErr(false);
    } else {
      setRefOneFrirstNameErr(false);
      setRefOneFrirstNameIsEmptyErr(false);
    }

    setReferenceOneName(item);
    //formData.append("refOneName", reference_one_name);
  }

  const referenceOneNumberHandler = (reference_one_number) => {
    let item = reference_one_number;
    if (item === "") {
      setRefOneNumberIsEmptyErr(true);
      setRefOneNumberErr(false);
    } else {
      setRefOneNumberErr(false);
      setRefOneNumberIsEmptyErr(false);
    }
    setReferenceOneNumber(item);
    
  }

  function referenceOneEmailHandler(e) {
    let item = e.target.value;
    let validEmail = validEmailRegex.test(item);
    if (item === "") {
      setRefOneEmailIsEmptyErr(true);
      setRefOneEmailErr(false);
    } else if (!validEmail) {
      setRefOneEmailErr(true);
      setRefOneEmailIsEmptyErr(false);
    } else {
      setRefOneEmailErr(false);
      setRefOneEmailIsEmptyErr(false);
    }
    setReferenceOneEmail(item);
    //formData.append("refOneEmail", reference_one_email);
  }

  function referenceTwoNameHandler(e) {
    let item = e.target.value;
    if (item === "") {
      setRefTwoFrirstNameIsEmptyErr(true);
      setRefTwoFrirstNameErr(false);
    } else if (item.length < 3 || item.length > 20) {
      setRefTwoFrirstNameErr(true);
      setRefTwoFrirstNameIsEmptyErr(false);
    } else {
      setRefTwoFrirstNameErr(false);
      setRefTwoFrirstNameIsEmptyErr(false);
    }
    setReferenceTwoName(item);
    
  }

  const referenceTwoNumberHandler = (reference_two_number) => {
    setRefTwoNumberIsEmptyErr(false)
    let item = reference_two_number;
    if (item === "") {
      setRefTwoNumberIsEmptyErr(true);
      setRefTwoNumberErr(false);
    } else {
      setRefTwoNumberErr(false);
      setRefTwoNumberIsEmptyErr(false);
    }
    setReferenceTwoNumber(item);
    
  }

  function referenceTwoEmailHandler(e) {
    let item = e.target.value;
    let validEmail = validEmailRegex.test(item);
    if (item === "") {
      setRefTwoEmailIsEmptyErr(true);
      setRefTwoEmailErr(false);
    } else if (!validEmail) {
      setRefTwoEmailErr(true);
      setRefTwoEmailIsEmptyErr(false);
    } else {
      setRefTwoEmailErr(false);
      setRefTwoEmailIsEmptyErr(false);
    }
    setReferenceTwoEmail(item);
    //formData.append("refTwoEmail", reference_two_email);
  }
  let formData = new FormData();
 

  const recaptchaRef = React.useRef();
  let token ='';
  let [USERID, setUSERID] = useState('');
  // 1. State for Jamat ID Card Number
const [jamatIdCardNumber, setJamatIdCardNumber] = useState("");
const [jamatIdCardNumberErr, setJamatIdCardNumberErr] = useState(false);
const [jamatIdCardNumberIsEmptyErr, setJamatIdCardNumberIsEmptyErr] = useState(false);

// 2. Handler for Jamat ID Card Number
function jamatIdCardNumberHandler(e) {
  let item = e.target.value;
  // Only numbers, length 6-20
  const valid = /^[0-9]{6,20}$/.test(item);
  if (item === "") {
    setJamatIdCardNumberIsEmptyErr(true);
    setJamatIdCardNumberErr(false);
  } else if (!valid) {
    setJamatIdCardNumberErr(true);
    setJamatIdCardNumberIsEmptyErr(false);
  } else {
    setJamatIdCardNumberErr(false);
    setJamatIdCardNumberIsEmptyErr(false);
  }
  setJamatIdCardNumber(item);
}

  async function registerUser(event) {
    event.preventDefault();
    setRecaptchaError(false);
    token = await recaptchaRef.current.executeAsync();
    if(token === false  || token === undefined|| token === null || token === ''){
      setRecaptchaError(true);
   }



    if (
      fname === "" &&
      lname === "" &&
      email === "" &&
      phone === "" &&
      country === "" &&
      city === "" &&
      refOneFrirstName === "" &&
      refTwoFrirstName === "" &&
      refOnePhone === "" &&
      refTwoPhone === "" &&
      cnicImage === "" &&
      reference_one_name === "" &&
      reference_two_name === "" &&
      reference_one_number === "" &&
      reference_two_number === "" &&
      reference_one_email === "" &&
      reference_two_email === ""
    ) {
      setFNameIsEmptyErr(true);
      setLNameIsEmptyErr(true);
      setEmailIsEmptyErr(true);
      setPhoneIsEmptyErr(true);
      setCountryIsEmptyErr(true);
      setCityIsEmptyErr(true);
      setRefOneFrirstNameIsEmptyErr(true);
      setRefTwoFrirstNameIsEmptyErr(true);
      setRefOneNumberIsEmptyErr(true);
      setRefTwoNumberIsEmptyErr(true);
      setCnicImageIsEmptyErr(true);
      setRefOneEmailIsEmptyErr(true);
      setRefTwoEmailIsEmptyErr(true);
    } else if (fname === "") {
      setFNameIsEmptyErr(true);
    } else if (lname === "") {
      setLNameIsEmptyErr(true);
    } else if (email === "") {
      setEmailIsEmptyErr(true);
    
    } else if (phone === "" || phone.length !== mobileNoLength) {
      setPhoneIsEmptyErr(true);
    } else if (country === "") {
      setCountryIsEmptyErr(true);
    } else if (city === "" || city === undefined || city.length < 3) {
      setCityIsEmptyErr(true);
    }
    else if(cnicImage === "" || undefined){
      setCnicImageIsEmptyErr(true);
      }
    else if (certificate === ""|| undefined) {
      setCertificateIsEmptyErr(true);
    }
     else if (reference_one_name === "") {
      setRefOneFrirstNameIsEmptyErr(true);
    } else if (reference_two_name === "") {
      setRefTwoFrirstNameIsEmptyErr(true);
    } else if (reference_one_number === "" || reference_one_number.length !== mobileNoLengthOne) {
      setRefOneNumberIsEmptyErr(true);
    } else if (reference_two_number === "" || reference_two_number.length !== mobileNoLengthTwo) {
      setRefTwoNumberIsEmptyErr(true);
    } else if (cnicImage.length < 1) {
      setCnicImageIsEmptyErr(true);
    } else if (reference_one_email === "") {
      setRefOneEmailIsEmptyErr(true);
    } else if (reference_two_email === "") {
      setRefTwoEmailIsEmptyErr(true);
    }
    else if (terms === "" || terms === undefined || terms === false) {
      setTermsIsEmptyErr(true);
    } 
    else if (jamatIdCardNumber === "") {
      setJamatIdCardNumberIsEmptyErr(true);
    } else if (!/^[0-9]{6,20}$/.test(jamatIdCardNumber)) {
      setJamatIdCardNumberErr(true);
    }
     else {

      formData.append("fname", fname);
      formData.append("lname", lname);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("country", country);
      formData.append("city", city);
      formData.append("reference_one_name", reference_one_name);
      formData.append("reference_two_name", reference_two_name);
      formData.append("reference_one_number", reference_one_number);
      formData.append("reference_two_number", reference_two_number);
      formData.append("reference_one_email", reference_one_email);
      formData.append("reference_two_email", reference_two_email);
      formData.append("scannedcnic", cnicImage);
      formData.append("certificate", certificate);
      formData.append("jamat_id_card_number", jamatIdCardNumber);
      setSubmitLoader(true);


      axios
        .post(`${API_BASE_URL}user/register`,

          formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }

        )
        .then(function (response) {
          
          //setUserID(response.data.data.user_id)
          localStorage.setItem("user_id", response.data.data.user_id);
          setUserID(response.data.data.user_id);
          setSubmitLoader(false);
          setSmShow(true);
          setresLogin(response.data)
          setUSERID(response.data.data.user_id);
        
          
        })
        .catch(function (error) {
          setSmShow(true);
          setSubmitLoader(false);
          setresLogin(error.response.data)

        });

    }
  }
  let [countriesData, setcountriesData] = useState([])
  let [cityData, setcityData] = useState([])
  let number=0;
  useEffect(() => {
   
    const country_keys = Object.keys(country_list);
    let countriesListData = country_keys.map((country_item, index) => {
      return (
        <option key={index} value={country_item}>
          {country_item}
        </option>
      );
    })
    setcountriesData(countriesListData)

  }, []);
  const countryChange = (e) => {
    const country_name = e.target.value;

    // setCityList(cities[country_name]);
    setCountry(e.target.value);
    let citiesList_data = country_list[country_name].map((item, i) => {
      return (
        <option key={i} value={item}>
          {item}
        </option>
      );
    }, this);
    setcityData(citiesList_data)
    // formData.append("country", country);
  };
  return (
    <>
      {/* <Modal
        size="sm"
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{responseLogin}</Modal.Body>
      </Modal> */}
      <TermModal onClose={() => setShow(false)} show={show} />
      <Header />
      <section className="register-page">
        <div className="container-fluid p-0 container-responsive">
          <div className="row ">
            <div className="col-lg-5">
              <Fixedbg />
            </div>
            <div className="col-lg-6">
              <div className="row pb-4">
                <div className="col pt-5">
                  <h2 className="h2_medum">
                    Create New{" "}
                    <span className="color-9F7854">
                      <strong>Account</strong>
                    </span>
                  </h2>
                  <p>
                  Fill in the below form to create a new account. Once the admin has approved your account, you will receive a notification and can then access the platform. 
                  </p>
                </div>
              </div>
              <form
                className="register-form"
                onSubmit={registerUser}
                encType='multipart/form-data'
              >
                <div className="form-row row mb-4">
                  <div className="col">
                    <label>
                      First Name <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control border-0 border-bottom bg-transparent"
                      value={fname}
                      onChange={fnameHandler}
                      required
                    />
                    {fnameIsEmptyErr ? <span className="error-msg">Enter First Name</span> : ""}
                    {fnameTypeErr ? <span className="error-msg">Enter Valid First Name</span> : ""}
                    {fnameErr ? (
                      <span className="error-msg">First Name must be 3 to 20 characters long</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col">
                    <label>
                      Last Name <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control border-0 border-bottom bg-transparent"
                      value={lname}
                      onChange={lnameHandler}
                      required
                    />
                    {lnameIsEmptyErr ? <span className="error-msg">Enter Last Name</span> : ""}
                    {lnameErr ? (
                      <span className="error-msg">Last Name must be 3 to 20 characters long</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-row row">
                  <div className="form-group mb-4 col-lg-6">
                    <label>
                      Email Address <span className="req">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control border-0 border-bottom bg-transparent"
                      id="inputEmail4"
                      value={email}
                      onChange={emailHandler}
                      required
                    />
                    {emailIsEmptyErr ? (
                      <span className="error-msg">Please enter an email address</span>
                    ) : (
                      ""
                    )}
                    {emailErr ? <span className="error-msg">Enter a valid email address</span> : ""}
                  </div>
                  <div className="form-group mb-4 col-lg-6">
                    <label>
                      Phone Number <span className="req">*</span>
                    </label>

                    <PhoneInput
                      inputClass="form-control border-0 border-bottom bg-transparent"
                      id="phone"
                      country={'pk'}
                      rules={{ required: true }} 
                      name="phone"
                      value={phone}
                      placeholder=""
                      onChange={(value, country, e) => {
                        setPhoneIsEmptyErr(false);
                        setMobileNoLength( country.format?.split(".").length - 1); 
                        setPhone(value); }} 
                         onBlur={(e, country) => {
                            let _length = country.format?.split(".").length - 1;
                            if (phone.length !== _length) { 
                              setPhoneIsEmptyErr(true); 
                              autoFocus: true
                          }
                        else {
                          setPhoneIsEmptyErr(false); 
  
                        } }} 
                            
                      
                    />


                    {phoneIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                    {phoneErr ? <span className="error-msg">Enter a valid phone number</span> : ""}
                  </div>
                </div>
                <div className="form-row row">
                  <div className="form-group mb-4 col-lg-6">
                    <label>
                      Country <span className="req">*</span>
                    </label>

                    <select
                      id="inputCountry"
                      className="form-control border-0 border-bottom bg-transparent"
                      value={country}
                      onChange={countryChange}
                      type="text"
                    >
                      {countriesData}

                    </select>
                  </div>
                  <div
                    className="form-group mb-4 col-lg-6"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    type="text"
                  >
                    <label>
                      City <span className="req">*</span>
                    </label>
                    <select
                      id="inputcity"
                      className={country ? "form-control border-0 border-bottom bg-transparent" : "disable form-control border-0 border-bottom bg-transparent"}
                      value={city}
                      onChange={cityHandler}
                      disabled={country ? false : true}
                    >
                      {cityData}
                      

                    </select>
                    { cityIsEmptyErr ? <span className="error-msg">Please select a city</span> : ""}
                  </div>
                </div>

                <div className="form-row row">
                  <div className="form-group mb-4 col-lg-12">
                    <label>
                      Jamat ID Card Number <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control border-0 border-bottom bg-transparent"
                      value={jamatIdCardNumber}
                      onChange={jamatIdCardNumberHandler}
                      required
                    />
                    {jamatIdCardNumberIsEmptyErr ? (
                      <span className="error-msg">Please enter Jamat ID Card Number</span>
                    ) : ""}
                    {jamatIdCardNumberErr ? (
                      <span className="error-msg">Enter a valid Jamat ID Card Number (6-20 digits)</span>
                    ) : ""}
                  </div>
                </div>    

                <div className="form-row row">
                  <div className="form-group mb-4 col-lg-6">
                    <label className="pb-2">
                      Upload Scanned CNIC <span className="req">*</span>
                    </label>
                    <label className="file">
                      <input
                        type="file"
                        accept=".png, .jpg, .jpeg"

                        onChange={handleImg}
                        className="form-control border-0 border-bottom bg-transparent"
                        id="uploadscannedCNIC"
                      />
                      <span className="file-custom"></span>
                      
                      { cnicImageIsEmptyErr ? <span className="error-msg">Please upload CNIC</span> : ""}
                      <span>{alt}</span>
                      {/* <img src={imgData}  /> */}
                    </label>
                  </div>
                  <div className="form-group mb-4 col-lg-6">
                    <label className="pb-2">
                      Upload Community Proof/ Jamat Id Card <span className="req">*</span>
                    </label>
                    <label className="file file-pdf">
                      <input
                        type="file"
                        accept=".png, .jpg, .jpeg"

                        onChange={certificateHandler}
                        className="form-control border-0 border-bottom bg-transparent"
                        id="uploadcommunityProof"
                      />
                      <span className="file-custom"></span>
                      { certificateIsEmptyErr ? <span className="error-msg">Please upload Community Proof</span> : ""}
                      <span>{certificateName}</span>
                    </label>
                  </div>
                </div>
                <div className="form-row row pt-4">
                  <h3>References from the Khoja Community:</h3>
                  <span className="reference py-2">Reference 1:</span>
                  <div className="form-group mb-4 col-lg-6">
                    <label>
                      First Name <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control border-0 border-bottom bg-transparent"
                      value={reference_one_name}
                      onChange={refOneFrirstNameHandler}
                      required
                    />
                    {refOneFrirstNameIsEmptyErr ? (
                      <span className="error-msg">Enter First Name</span>
                    ) : (
                      ""
                    )}
                    {refOneFrirstNameErr ? (
                      <span className="error-msg">First Name must be 3 to 20 characters long</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group mb-4 col-lg-6">
                    <label>
                      Phone Number <span className="req">*</span>
                    </label>
                    <PhoneInput
                      inputClass="form-control border-0 border-bottom bg-transparent"
                      id="phone"
                      country={'pk'}
                      rules={{ required: true }} 
                      name="phone"
                      placeholder=""
                      onChange={(value, country, e) => {
                        setRefOneNumberIsEmptyErr(false);
                        setMobileNoLengthOne( country.format?.split(".").length - 1); 
                         setReferenceOneNumber(value); }} 
                         onBlur={(e, country) => {
                            let _length = country.format?.split(".").length - 1;
                            if (reference_one_number.length !== _length) { 
                            setRefOneNumberIsEmptyErr(true); 
                          }
                        else {
                          setRefOneNumberIsEmptyErr(false); 
  
                        } }} 
                            value={reference_one_number}
                    />

                    {refOneNumberIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                    {refOneNumberErr ? (
                      <span className="error-msg">Enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-row row pt-4">
                  <div className="form-group mb-4 col-lg-12">
                    <label>
                      Email Address <span className="req">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control border-0 border-bottom bg-transparent"
                      id="inputEmail4"
                      value={reference_one_email}
                      onChange={referenceOneEmailHandler}
                      required
                    />
                    {refOneEmailIsEmptyErr ? (
                      <span className="error-msg">Please enter an email address</span>
                    ) : (
                      ""
                    )}
                    {refOneEmailErr ? (
                      <span className="error-msg">Enter a valid email address</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-row row pt-4">
                  {/* <h3>References from Khoja Community</h3> */}
                  <span className="reference py-2">Reference 2:</span>
                  <div className="form-group mb-4 col-lg-6">
                    <label>
                      First Name <span className="req">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control border-0 border-bottom bg-transparent"
                      value={reference_two_name}
                      onChange={referenceTwoNameHandler}
                      required
                    />
                    {refTwoNameIsEmptyErr ? <span className="error-msg">Enter First Name</span> : ""}
                    {refTwoNameErr ? (
                      <span className="error-msg">First Name must be 3 to 20 characters long</span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group mb-4 col-lg-6">
                    <label>
                      Phone Number <span className="req">*</span>
                    </label>
                    <PhoneInput
                      inputClass="form-control border-0 border-bottom bg-transparent"
                      id="phone"
                      country={'pk'}
                      rules={{ required: true }} 
                      name="phone" 
                      placeholder=""
                      onChange={(value, country, e) => {
                      setRefTwoNumberIsEmptyErr(false);
                      setMobileNoLengthTwo( country.format?.split(".").length - 1); 
                       setReferenceTwoNumber(value); }} 
                       onBlur={(e, country) => {
                          let _length = country.format?.split(".").length - 1; 
                          if (reference_two_number.length !== _length) { 
                          setRefTwoNumberIsEmptyErr(true); 
                          autoFocus: true
                        }
                      else {
                        setRefTwoNumberIsEmptyErr(false); 

                      } }} 
                          value={reference_two_number} 
                          
                          />
                    {refTwoNumberIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                    {refTwoNumberErr ? (
                      <span className="error-msg">Enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-row row pt-4">
                  <div className="form-group mb-4 col-lg-12">
                    <label>
                      Email Address <span className="req">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control border-0 border-bottom bg-transparent"
                      id="inputEmail4"
                      value={reference_two_email}
                      onChange={referenceTwoEmailHandler}
                      required
                    />
                    {refTwoEmailIsEmptyErr ? (
                      <span className="error-msg">Please enter an email address</span>
                    ) : (
                      ""
                    )}
                    {refTwoEmailErr ? (
                      <span className="error-msg">Enter a valid email address</span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                
                <div className="form-group mb-4 justify-content-between d-flex mb-5">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                      value={true}
                      onChange={termshandler}
                      
                    />
                    <label className="form-check-label">
                    I agree to the <span className="req terms-condition" onClick={handleShow}>Terms and Conditions</span>
                    </label>
                    <br></br>
                    { termsIsEmptyErr ? (
                      <span className="error-msg">Please agree on Terms and Conditions</span>
                    ) : (
                      ""
                    )}
                  </div>
                  {/* <Modal show={submitLoader} onHide={loaderClose}>
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </Modal> */}
                  <div>
                    <button 
                      type="submit"
                      value="Register"
                      className="btn-full-color"

                    ><Spinner
                        as="span"
                        animation={submitLoader ? 'border' : ''}
                        size="sm"
                        role="status"
                        aria-hidden="false"
                      />
                      Sign Up
                    </button>
                  </div>
                  <ReCAPTCHA
                                sitekey="6LfXbVggAAAAAF20tZ9IMRYPIeWhnPJ3QJ12c1Bf"
                                ref={recaptchaRef}
        size="invisible"
                              />
                              {
                                 recaptchaError ? (
                                    <span className="error-msg">Please verify that you are not a robot</span>
                                 ) : (
                                    ""
                                 )
                                 
                              }
                </div>
              </form>
              <SubmitPopup
                onClose={() => setSmShow(false)}
                show={smShow}
                title={resLogin.message}
              />
              <div  className={USERID ? "register" : "register disable"}>
                {console.log(USERID)}
              <h3>Confirm Email by verifying OTP</h3>
              <Otp login={false} user_id={user_id}/>
              </div>
            </div>
          </div>
          <div className="resposive_footer">
            <Footer />
          </div>
        </div>
      </section>
    </>
  );
};
export default Signup;
